export default "https://cdn-static.gokick.com/assets/3cd141d05df56e6b81a0153ff619f4101846aa93/images/picture-of-you.b930d7b92f771d9006a5673f9ae1716c.svg";